import { render, staticRenderFns } from "./club.vue?vue&type=template&id=03fe1fd2&"
import script from "./club.vue?vue&type=script&lang=js&"
export * from "./club.vue?vue&type=script&lang=js&"
import style0 from "./club.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fe1fd2')) {
      api.createRecord('03fe1fd2', component.options)
    } else {
      api.reload('03fe1fd2', component.options)
    }
    module.hot.accept("./club.vue?vue&type=template&id=03fe1fd2&", function () {
      api.rerender('03fe1fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/club.vue"
export default component.exports